import { StatTile as SharedStatTile } from "@bednbody/ui/components/stat-tile";
import type { Icon } from "@phosphor-icons/react";
import type { ReactNode } from "react";

interface StatTileProps {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  icon: Icon;
  highlight?: boolean;
  className?: string;
}

/** Roster value/detail adapter; presentation is owned by the shared stat tile. */
export function StatTile({ label, value, detail, icon, highlight, className }: StatTileProps) {
  return (
    <SharedStatTile
      layout="compact"
      label={label}
      detail={detail}
      icon={icon}
      highlight={highlight}
      className={className}
    >
      {value}
    </SharedStatTile>
  );
}
